module.exports = __webpack_public_path__ + "img/node-hvac-transparent.52f3f840.webp";